import { render, staticRenderFns } from "./UniversityCareerListComponent.vue?vue&type=template&id=0a9bc37e&"
import script from "./UniversityCareerListComponent.vue?vue&type=script&lang=js&"
export * from "./UniversityCareerListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports